import moment from 'moment'
import axios from 'axios'

export default {
	methods: {
		_googleTimeZone(lat, lng, data) {
			let _data = new moment(data, $sessao.getDateFormat('HH:mm'))
			const latFiltrada = lat.replace(',', '.')
			const lngFiltrada = lng.replace(',', '.')

			return new Promise((resolve) => {
				let url = `https://maps.googleapis.com/maps/api/timezone/json?location=${latFiltrada},${lngFiltrada}&timestamp=${_data.unix()}&key=${
					this._googleKey
				}`

				// return data
				this._httpGetExternal(url, (resposta) => {
					if (resposta._request) {
						resolve(resposta)
					} else {
						throw new Error('erro no request')
					}
				})
			})
		},

		_httpGetExternal(url, callback, dataType) {
			if (_.isNil(dataType)) {
				dataType = 'json'
			}

			var rt = {
				data: '',
				request: false,
				erro: ''
			}

			jQuery.ajax({
				type: 'GET',
				url: url,
				dataType: dataType,
				success(retorno) {
					if (dataType === 'HTML') {
						callback(retorno)
						return
					}

					retorno._request = true
					if (!_.isNil(retorno.status)) {
						if (retorno.status == 'sucesso') {
							retorno._status = true
						} else {
							retorno._status = false
						}
					} else {
						retorno._status = true
					}

					callback(retorno)
				},
				error(e) {
					console.error('ERRRRROO', e)
					rt._request = false
					rt.erro = e
					//callback(rt)
					bus.$emit('modal-erro-show', e, url)
				}
			})
		},

		_httpGet(url, callback, token) {
			var rt = {
				data: '',
				request: false,
				erro: ''
			}

			let tk = ''

			if (_.isNil(token)) {
				tk = this.getToken()
			} else {
				tk = token
			}

			jQuery.ajax({
				type: 'GET',
				headers: {Authorization: tk},
				url: this.getURL_WS(url),
				dataType: 'json',
				success: function (retorno) {
					retorno._request = true
					if (!_.isNil(retorno.status)) {
						if (retorno.status == 'sucesso') {
							retorno._status = true
						} else {
							retorno._status = false
						}
					} else {
						retorno._status = true
					}

					callback(retorno)
				},
				error: function (e) {
					console.error('ERRRRROO', e)
					rt._request = false
					rt.erro = e
					//callback(rt)
					if (e.status === 520 || e.status === 0) {
						window.bus.$emit('exibir-notificacao', {
							type: 'danger',
							text: 'Ocorreu um erro em sua conexão, por favor atualize a pagina.<br/><br/> Código: 520',
							duration: -10
						}) 
					} else {
						bus.$emit('modal-erro-show', e, this.getURL_WS(url))
					}
				}
			})
		},

		_httpPost(url, data, callback, token) {
			var rt = {
				data: '',
				request: false,
				erro: ''
			}

			let tk = ''

			if (_.isNil(token)) {
				tk = this.getToken()
			} else {
				tk = token
			}

			jQuery.ajax({
				type: 'POST',
				headers: {Authorization: tk},
				url: this.getURL_WS(url),
				data: {data: JSON.stringify(data)},
				dataType: 'json',
				success: function (retorno) {
					retorno._request = true
					if (retorno.status == 'sucesso') {
						retorno._status = true
					} else {
						retorno._status = false
					}

					callback(retorno)
				},
				error: function (e) {
					rt._request = false
					rt.erro = e
					//callback(rt)
					bus.$emit('modal-erro-show', e, this.getURL_WS(url))
				}
			})
		},

		_httpService(url, method, data, callback) {
			var rt = {
				data: '',
				request: false,
				erro: ''
			}

			jQuery.ajax({
				type: method,
				headers: {Authorization: this._keyServices},
				url: this.getURL_SERVICES(url),
				data: data != null ? JSON.stringify(data) : null,
				contentType: 'application/json',
				success: function (retorno) {
					callback(retorno)
				},
				error: function (e) {
					rt._request = false
					rt.erro = e
					// callback(rt)
					console.error(e)
					bus.$emit('modal-erro-show', e, this.getURL_SERVICES(url))
				}
			})
		},
		_axios(url, method, options = {}) {
			const request = axios.create({
				baseURL: this.getURL_WS(),
				headers: {
					Authorization: this.getToken()
				}
			})
			request({
				method,
				url,
				...options
			})
				.then((response) => {
					let retorno = response.data
					if (typeof retorno !== 'string' && typeof retorno !== 'boolean') {
						retorno._request = true
					}

					if (retorno.status) {
						if (retorno.status == 'sucesso' && typeof retorno !== 'string' && typeof retorno !== 'boolean') {
							retorno._status = true
						} else {
							if (retorno.status == 'erro' && retorno.message) {
								window.bus.$emit('exibir-notificacao', {
									type: 'danger',
									text: retorno.message
								})
							} else {
								const responseText = retorno.responseText
									? retorno.responseText
									: retorno
								retorno = {
									responseText: responseText,
									_status: false,
									_request: false,
									status: 500
								}
								window.bus.$emit(
									'modal-erro-show',
									retorno,
									this.getURL_WS(url)
								)
							}
						}
					}

					if (options.callback) {
						options.callback(retorno)
					}
				})
				.catch((retorno) => {
					if (retorno.response?.status === 500) {
						window.bus.$emit(
							'modal-erro-show',
							{
								responseText: retorno.response.data,
								_status: false,
								_request: false,
								status: 500
							},
							this.getURL_WS(url)
						)
					} else if (
						retorno.response &&
						retorno.response.status < 500 &&
						retorno.response.status >= 400 &&
						retorno.response.data?.message
					) {
						window.bus.$emit('exibir-notificacao', {
							type: 'danger',
							text: retorno.response.data.message
						})
					}
					if (options.catch) {
						options.catch(retorno)
					}
					if (retorno instanceof Error) {
						console.error(retorno)
					}
				})
				.finally((retorno) => {
					if (options.finally) {
						options.finally(retorno)
					}
				})
		},
		_axios2(url, method, options = {}) {
			const request = axios.create({
				baseURL: this.getURL_WS(),

				headers: {
					Authorization: this.getToken()
				}
			})

			request({
				method,

				url,

				...options
			})
				.then((response) => {
					let retorno = response.data

					if (options.callback) {
						options.callback(retorno)
					}
				})

				.catch((retorno) => {
					if (retorno.response?.status === 500) {
						window.bus.$emit(
							'modal-erro-show',
							{
								responseText: retorno.response.data,

								_status: false,

								_request: false,

								status: 500
							},
							this.getURL_WS(url)
						)
					} else if (
						retorno.response &&
						retorno.response.status < 500 &&
						retorno.response?.status >= 400 &&
						retorno.response?.message
					) {
						window.bus.$emit('exibir-notificacao', {
							type: 'danger',
							text: retorno.response.message
						})
					}

					if (options.catch) {
						options.catch(retorno)
					}

					if (retorno instanceof Error) {
						console.error(retorno)
					}
				})

				.finally((retorno) => {
					if (options.finally) {
						options.finally(retorno)
					}
				})
		},
		_httpGetDownload(url, fileName, token, callback = null) {
			var rt = {
				data: '',
				request: false,
				erro: ''
			}

			let tk = ''

			if (_.isNil(token)) {
				tk = this.getToken()
			} else {
				tk = token
			}
			let request = new XMLHttpRequest()
			request.open('GET', this.getURL_WS(url), true)
			request.setRequestHeader(
				'Content-Type',
				'application/x-www-form-urlencoded; charset=UTF-8'
			)
			request.setRequestHeader('Authorization', tk)
			request.responseType = 'blob'
			request.onload = function (e) {
				if (this.status === 200) {
					let blob = this.response
					if (window.navigator.msSaveOrOpenBlob) {
						window.navigator.msSaveBlob(blob, fileName)
					} else {
						let downloadLink = window.document.createElement('a')
						let contentTypeHeader = request.getResponseHeader('Content-Type')
						downloadLink.href = window.URL.createObjectURL(
							new Blob([blob], {type: contentTypeHeader})
						)
						downloadLink.download = fileName
						document.body.appendChild(downloadLink)
						downloadLink.click()
						document.body.removeChild(downloadLink)
					}

					if (callback) {
						callback()
					}
				}
			}
			request.send()
		}
	}
}
